function UserPermissionSelect({ value, onChange, permissionSets, disabled }) {
	return (
		<div>
			<label className="block text-sm font-bold mb-1">
				Permission Set
			</label>
			<select
				name="permission-set"
				value={value || ""}
				onChange={onChange}
				required
				disabled={disabled}
			>
				<option value="" disabled>
					Select permission set
				</option>
				{Object.keys(permissionSets).map((key) => (
					<option key={key} value={key}>
						{permissionSets[key].title || key}
					</option>
				))}
			</select>
		</div>
	);
}

export default UserPermissionSelect;
